export default __webpack_public_path__ + "static/media/004-microwave oven.d8626e54.svg";